const TOKEN_KEY = 'yousen_access_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function portalHomeUrl() {
  let role = 'cra'
  try {
    const profile = JSON.parse(localStorage.getItem('ysjh_user_profile') || '{}')
    if (profile.role) role = profile.role
    else if (Array.isArray(profile.roles) && profile.roles[0]) {
      role = profile.roles[0].code || profile.roles[0] || role
    }
  } catch (err) {
    /* keep default */
  }
  return '/prototype/company-home.html?role=' + encodeURIComponent(role)
}

